import React, { forwardRef } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../../common/SvgIcon';
import BriefFamilySelector from './BriefFamilySelector';

const BriefFamily = (
  { value, invalid, proPlatform, className, onChange, children },
  ref,
) => (
  <div ref={ref} className={cn('tab', className)}>
    <div className="tab_question">Question 2 of {proPlatform ? '5' : '7'}</div>
    <div className="tab_tag">
      <SvgIcon icon="icon-question-step-2" />
    </div>
    <div className="tab_title">
      <div className={cn('-bold', { 'has-error -error-position-right': invalid })}>
        Who lives in your property?
        {invalid && <div className="form-error">please, specify your family members</div>}
      </div>
    </div>
    <div className="member-selection">
      <BriefFamilySelector
        title="Adults"
        type="adult"
        value={value.adults}
        invalid={invalid}
        className="-col-2 adults"
        onChange={members => onChange(members, 'adults')}
      />
      <BriefFamilySelector
        title="Children"
        type="child"
        value={value.children}
        invalid={invalid}
        className="-col-2 children"
        onChange={members => onChange(members, 'children')}
      />
      <BriefFamilySelector
        title="Pets"
        type="pet"
        value={value.pets}
        invalid={invalid}
        className="-col-2 pets"
        onChange={members => onChange(members, 'pets')}
      />
    </div>
    {children}
  </div>
);

export default forwardRef(BriefFamily);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefFamily/BriefFamily.js